<template>
  <div class="player" :data-url="howlerData.src[0]">
    <template v-if="message">
      {{ message }}
    </template>
    <template v-else>
      <div v-if="showBtn" class="btn">
        <svg-icon v-show="!playing" icon-class="play" class="status-icon" @click.native="play"></svg-icon>
        <svg-icon v-show="playing" icon-class="pause" class="status-icon" @click.native="pause"></svg-icon>
      </div>
      <div class="progress">
        <el-slider
          v-model="playProgressSecond"
          :max="durationSecond"
          :format-tooltip="formatProgressTooltip"
          @mousedown.native="handleMouseDown"
          @mouseup.native="handleMouseUp"
          @change="setPosition"
        >
        </el-slider>
      </div>
      <div class="time">
        {{ formatProgressTooltip(playProgressSecond) }}
        /
        {{ formatProgressTooltip(durationSecond) }}
      </div>
    </template>
  </div>
</template>

<script>
import { Howl, Howler } from 'howler'
import { numberToTime } from '@/utils/dateUtil'
// import commonService from '@/api/common'

export default {
  name: 'Player',
  props: {
    type: {
      type: String,
      default: 'mp3'
    },
    howlerData: {
      type: Object,
      required: true
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    transcode: {
      type: Boolean,
      default: false
    },
    mediaId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      soundId: null,
      playProgress: 0,
      currentTime: 0,
      duration: 0,
      playing: false,
      message: '',
    }
  },
  computed: {
    /**
     * @returns {Number}
     */
    playProgressSecond: {
      get() {
        return parseInt(this.playProgress / 1000, 10)
      },
      set(value) {
        this.playProgress = value * 1000
      }
    },
    /**
     * @returns {Number}
     */
    durationSecond() {
      return parseInt(this.duration / 1000, 10)
    }
  },
  watch: {
    howlerData: {
      deep: true,
      async handler() {
        this.pause()
        await this.init()
        this.play()
      }
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    if (this.hower) {
      this.hower.off()
      this.hower.stop()
    }
  },
  destroyed() {
    if (this.hower) {
      this.hower.unload()
    }
    // console.timeEnd('audio')
  },
  methods: {
    async init() {
      const { howlerData, type } = this
      let url
      if (!url) {
        url = howlerData.src[0]
        if (type && !Howler.codecs(type)) {
          const message = `当前浏览器不支持播放${type}类型文件`
          this.message = message
          return this.$alert(message, '提示', {
            type: 'warning'
          })
        }
      }

      // console.time('audio')
      const startTime = Date.now()
      this.startTime = startTime
      console.log(`init time ${startTime}`)
      const hower = this.hower = new Howl({
        html5: true,
        ...this.howlerData,
        src: [url]
      })
      if (this.autoplay) {
        this.play()
      }

      hower.on('load', () => {
        // console.timeLog('audio', 'audio loaded')
        console.log(`load time ${Date.now() - startTime}`)
        this.duration = hower.duration() * 1000 // 毫秒

        this.$emit('load')
      })
      hower.on('play', () => {
        // console.timeLog('audio', 'audio play start')
        console.log(`start play ${Date.now()}`)
        this.playing = true

        this.getPosition()
        this.$emit('play')
      })
      hower.on('pause', () => {
        // console.timeLog('audio', 'audio play pause')
        console.log(`pause play ${Date.now()}`)
        this.playing = false

        this.$emit('pause')
        this._cancelChange()
      })
      hower.on('stop', () => {
        // console.timeLog('audio', 'audio play stop')
        console.log(`stop play ${Date.now()}`)
        this.playing = false

        this.$emit('stop')
        this._cancelChange()
      })
      hower.on('end', () => {
        // console.timeLog('audio', 'audio play end')
        this.playing = false

        this.$emit('end')
        this._cancelChange()
        console.log(`end play ${Date.now()}`)
      })
      hower.on('seek', (soundId) => {
        console.log(`seek play ${Date.now()}`)
        this.getPosition()
      })
    },

    _cancelChange() {
      // this.craf(this.timeHandler)
      try {
        clearTimeout(this.timeHandler)
      } catch (error) {
        //
      }
    },

    getPosition() {
      if (this._isBeingDestroyed || !this.playing) {
        return
      }

      const current = this.hower.seek(null, this.soundId)
      // current 有可能获取回来的是一个 Howl 对象，雾WTF？
      if (current && typeof current === 'number') {
        if (!this.sliding) { // 如果正在人工拖动时间抽，不改变slider
          this.playProgress = current * 1000
        }

        this.$emit('position-change', current)
      }
      this.timeHandler = setTimeout(() => {
        this.getPosition()
      }, 20)
      // console.log(this.timeHandler)
      // this.timeHandler = requestAnimationFrame(_ => {
      //   this.getPosition()
      // })
    },

    formatProgressTooltip(val) {
      return numberToTime(val)
    },

    handleMouseDown(evt) {
      this.sliding = true
    },
    handleMouseUp(evt) {
      this.sliding = false
    },

    /**
     *
     * @param {Int} value 秒
     */
    setPosition(value) {
      console.log('slide change')
      this._cancelChange()
      // console.timeLog('audio', `position seek: ${value / 1000}`)
      this.playProgress = value
      this.hower.seek(value, this.soundId)
      this.$emit('slider-change', value * 1000)
    },

    play() {
      console.log('audio play')
      this.soundId = this.hower.play()
    },

    pause() {
      this.hower.pause()
    },

    /**
     * @param {Number} value 毫秒
     */
    seek(value) {
      this.hower.seek(value / 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.player {
  display: flex;
  width: 100%;
  padding: 8px 16px;
  background-color: $lightBgColor;

  .btn {
    width: 38px;
    height: 38px;
    line-height: 38px;
    border-radius: 19px;
    text-align: center;
    margin: 0 8px 0 0;

    &:hover {
      background-color: $bgColor;
    }
  }
  .status-icon {
    color: $primary;
    cursor: pointer;

  }
}
.progress {
  flex-grow: 1;
}
.time {
  margin: 0 0 0 8px;
  // width: 100px;
  line-height: 38px;
}
</style>
